// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"style_wrapper__OERCk","sectionsWrapper":"style_sectionsWrapper__1Z5IX"};